import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { endpointManager } from '../../../services/endpoint.service';

export interface IWireFees {
    fees: {arrivalDate: string, fee: number}[];
}

export const getWireFees = () => {
  const { getWireFeesUrl } = endpointManager();
  return useQuery(
    'getWireFees',
    async (): Promise<IWireFees> => {
      const res = await httpService.get(getWireFeesUrl());
      return res.data;
    },
    { enabled: false },
  );
};
